var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"94f03cd5f5dc279241fb77d8b259201a9334be0e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["order-simply@order-simply"]={id:"94f03cd5f5dc279241fb77d8b259201a9334be0e"};
      